import { z } from 'zod';

export const phenomenonSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  short_description: z.string().optional()
});

const categorySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  phenomena: z.array(phenomenonSchema)
});

export const getCategoryWithPhenomenaResponseSchema = z.array(categorySchema);
